// Events
export const dealerLocatorResultsOpen = 'dealer_locator_results_open';
export const dealerLocatorGeolocationClick = 'dealer_locator_geolocation_click';
export const dealerLocatorGetDirections = 'dealer_locator_get_directions';
export const dealerLocatorDetailView = 'dealer_locator_detail_view';
export const dealerLocatorContactClick = 'dealer_locator_contact_click';
export const brochuresResultsOpen = 'brochures_results_open';
